<template>
  <v-container fluid class="px-0 py-0">
    <v-layout row>
      <v-flex xs12>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from '@/store'

export default {
  name: 'StandardItemType',
  data () {
    return {}
  },
  beforeRouteEnter (to, from, next) {
    console.log('beforeRouteEnter:StandardItemType ')
    store.dispatch('standardItems/setLoading', true)
    store.dispatch('standardItems/get')
      .then(result => {
        store.dispatch('standardItems/setLoading', false)
        store.dispatch('standardItems/itemTypes/setRoute', { to, from, next })
      })
  },
  beforeRouteUpdate (to, from, next) {
    console.log('beforeRouteUpdate: standardItemsType')
    store.dispatch('standardItems/setLoading', true)
    store.dispatch('standardItems/get')
      .then(result => {
        store.dispatch('standardItems/setLoading', false)
        store.dispatch('standardItems/itemTypes/setRoute', { to, from, next })
      })
  },
  beforeRouteLeave (to, from, next) {
    console.log('beforeRouteLeave: standardItemsTpe')
    store.dispatch('standardItems/itemTypes/emptyCurrent', true)
    next()
  }
}
</script>
